export const TIPS_MODULE = {
  ATTRIBUTE_REPOSITORY: 'ATTRIBUTE_REPOSITORY',
  ASSET_DEFINITION: 'ASSET_DEFINITION',
  GEO_POLICY: 'GEO_POLICY',
  CONTROL_POLICY: 'CONTROL_POLICY',
  LANGUAGE_CONTROL_POLICY: 'LANGUAGE_CONTROL_POLICY',
  MASTERS: 'MASTERS',
  MANAGE_ROLE: 'MANAGE_ROLE',
  MANAGE_USER: 'MANAGE_USER',
  MANAGE_CONTENT: 'MANAGE_CONTENT',
  MANAGE_PARTNER: 'MANAGE_PARTNER',
  BULK_UPDATE: 'BULK_UPDATE',
  BULK_STATE_CHANGE: 'BULK_STATE_CHANGE',
  INTERACTIVE_BULK_UPDATE: 'INTERACTIVE_BULK_UPDATE',
  BULK_TRANSCODING: 'BULK_TRANSCODING',
  MANAGE_FILES: 'MANAGE_FILES',
  MANAGE_TIPS: 'MANAGE_TIPS',
  SNP_REVIEW_REPORT: 'SNP_REVIEW_REPORT',
}

const TIPS_SELECTION: any = {
  ATTRIBUTE_REPOSITORY: {
    MODULE: 'Attribute Repository',
    VIEW: 'View Attribute',
    EDIT: 'Edit Attribute',
    CREATE: 'Create Attribute',
  },
  ASSET_DEFINITION: {
    MODULE: 'Asset Definition',
    VIEW: 'View Asset Type',
    EDIT: 'Edit Asset Type',
    CREATE: 'Create Asset Type',
  },
  GEO_POLICY: {
    MODULE: 'Geo Policy',
    VIEW: 'View Geo Policy',
    EDIT: 'Edit Geo Policy',
    CREATE: 'Create Geo Policy',
  },
  CONTROL_POLICY: {
    MODULE: 'Entitlement Control Policy',
    VIEW: 'View Entitlement Control Policy',
    EDIT: 'Edit Entitlement Control Policy',
    CREATE: 'Create Entitlement Control Policy',
  },
  LANGUAGE_CONTROL_POLICY: {
    MODULE: 'Language Control Policy',
    VIEW: 'View Language Control Policy',
    EDIT: 'Edit Language Control Policy',
    CREATE: 'Create Language Control Policy',
  },
  MASTERS: {
    MODULE: 'Master',
    VIEW: 'View Value',
    EDIT: 'Edit Value',
    CREATE: 'Create Value',
  },
  MANAGE_ROLE: {
    MODULE: 'Role Management',
    VIEW: 'View Role',
    EDIT: 'Edit Role',
    CREATE: 'Create Role',
  },
  MANAGE_USER: {
    MODULE: 'User Management',
    VIEW: 'View User',
    EDIT: 'Edit User',
    CREATE: 'Create User',
  },
  MANAGE_PARTNER: {
    MODULE: 'Inbound Partners',
    VIEW: 'View Partner',
    EDIT: 'Update Partner',
    CREATE: 'Create Partner',
  },
  BULK_UPDATE: {
    MODULE: 'Bulk Update',
    VIEW: 'View Job',
    EDIT: 'Create Job',
    CREATE: 'Create Job',
  },
  BULK_STATE_CHANGE: {
    MODULE: 'Bulk State Change',
    VIEW: 'View Job',
    EDIT: 'Create Job',
    CREATE: 'Create Job',
  },
  INTERACTIVE_BULK_UPDATE: {
    MODULE: 'Interactive Bulk Update',
    VIEW: 'View Job',
    EDIT: 'Create Job',
    CREATE: 'Create Job',
  },
  BULK_TRANSCODING: {
    MODULE: 'Bulk Re-Transcoding',
    VIEW: 'View Job',
    EDIT: 'Create Job',
    CREATE: 'Create Job',
  },
  MANAGE_CONTENT: {
    MODULE: 'Manage Content',
    RIGHTS_AND_AVAILABILITY: {
      VIEW: 'Asset Creation: Rights & Availability - View',
      UPDATE: 'Asset Creation: Rights & Availability - Edit',
    },
    BUSINESS_RULES: {
      VIEW: 'Asset Creation: Business Rules - View',
      UPDATE: 'Asset Creation: Business Rules - Edit',
    },
    CONTENT_MEDIA_VIDEO: {
      VIEW: 'Asset Creation: Content Media: Video - View',
      UPDATE: 'Asset Creation: Content Media: Video - Edit',
    },
    CONTENT_MEDIA_IMAGE: {
      VIEW: 'Asset Creation: Content Media: Images - View',
      UPDATE: 'Asset Creation: Content Media: Images - Edit',
    },
    DESCRIPTIVE_METADATA: {
      VIEW: 'Asset Creation: Descriptive Metadata - View',
      UPDATE: 'Asset Creation: Descriptive Metadata - Edit',
    },
    TECHNICAL_METADATA: {
      VIEW: 'Asset Creation: Technical Metadata - View',
      UPDATE: 'Asset Creation: Technical Metadata - Edit',
    },
    ADVERTISEMENT_METADATA: {
      VIEW: 'Asset Creation: Advertisement Metadata - View',
      UPDATE: 'Asset Creation: Advertisement Metadata - Edit',
    },
    SEO_METADATA: {
      VIEW: 'Asset Creation: SEO Metadata - View',
      UPDATE: 'Asset Creation: SEO Metadata - Edit',
    },
    SPORTS_METADATA: {
      VIEW: 'Asset Creation: Sports Metadata - View',
      UPDATE: 'Asset Creation: Sports Metadata - Edit',
    },
    MISCELLANEOUS_METADATA: {
      VIEW: 'Asset Creation: Miscellaneous Metadata - View',
      UPDATE: 'Asset Creation: Miscellaneous Metadata - Edit',
    },
    CHECKLIST: {
      VIEW: 'Asset Creation: Checklist',
      UPDATE: 'Asset Creation: Checklist',
    },
  },
  MANAGE_FILES: {
    MODULE: 'Manage Files',
    VIEW: 'View Job',
    EDIT: 'Create Job',
  },
  MANAGE_TIPS: {
    MODULE: 'Manage Tips',
    VIEW: 'View Tips',
    EDIT: 'Edit Tips',
  },
  SNP_REVIEW_REPORT: {
    MODULE: 'SNP Review Report',
    VIEW: 'View Job',
    EDIT: 'Edit Attribute',
  },
  AD_BREAK_POLICY: {
    MODULE: 'Ad Break Policy',
    VIEW: 'View Ad Break Policy',
    CREATE: 'Create Ad Break Policy',
    EDIT: 'Edit Ad Break Policy',
  },
}

const formatViewTootipData = (records: any) => {
  const tootipsData: any = {}
  records.forEach((record: any) => {
    const { module, page } = record
    if (tootipsData[module]) {
      tootipsData[module] = {
        ...tootipsData[module],
        [page]: record?.tooltipMessages,
      }
    } else {
      tootipsData[module] = {
        [page]: record?.tooltipMessages,
      }
    }
  })
  return tootipsData
}

export const getTipsForPage = (
  tipsDataRes: any = [],
  module: string,
  pageType: string,
  page?: string,
) => {
  try {
    let tips = []
    const tipsData = formatViewTootipData(tipsDataRes)
    const tipsModule = TIPS_SELECTION[module.toUpperCase()]
    if (tipsModule?.MODULE && tipsData[tipsModule.MODULE]) {
      const dataMudule = tipsModule.MODULE
      if (page) {
        const dataPage = tipsModule[page.toUpperCase()]
        const dataPageType = dataPage[pageType.toUpperCase()]
        tips = tipsData[dataMudule][dataPageType] || []
      } else {
        const dataPageType = tipsModule[pageType.toUpperCase()]
        tips = tipsData[dataMudule][dataPageType] || []
      }
    }
    return tips
  } catch (_error) {
    return []
  }
}

export function generateRandomId() {
  return Date.now().toString(36) + Math.random().toString(36).slice(2, 7)
}
